import { Tooltip, Text } from "@mantine/core"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"
import { MatrixOrientation } from "../matrix-css-grid"
import css from "./cells.module.css"

export function DayHeaderCell({
  orientation,
  day,
}: {
  orientation: MatrixOrientation
  day: dayjs.Dayjs
}) {
  const { t } = useTranslation("app_server")
  return (
    <div
      className={css["day-header-cell"]}
      style={{
        top: orientation == "normal" ? 0 : undefined,
        left: orientation == "transpose" ? 0 : undefined,
      }}
    >
      <Tooltip label={day.format("dddd LL")}>
        <Text
          size={"xs"}
          fw={700}
          style={
            orientation === "transpose"
              ? {
                  writingMode: "vertical-lr",
                  transform: "rotate(180deg)",
                }
              : undefined
          }
        >
          {day.isToday() ? t("Today") : day.format("ddd DD.MM.")}
        </Text>
      </Tooltip>
    </div>
  )
}
